export default {
  profileShare: {
    title: 'Share your Kintell profile',
    body: ' If you’d like to share your Kintell profile page with a friend or colleague, simply copy the URL below.',
    copy: 'Copy',
    share: 'Share',
    preview: 'preview'
  },
  welcome: {
    learner: {
      title: 'Welcome to the Kintell community!',
      body: 'Hi {name}, you’re now signed up to Kintell! Woop! You can now either browse our Advisors or become an Advisor yourself by creating a Kintell Card.',
    },
  },
  whatIsKintell: {
    title: 'What is Kintell?',
    body: 'Kintell is the global knowledge network - a new way of getting and giving independent advice.'
  }
}
